import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import dojoDateLocale from 'dojo/date/locale';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import RatingDialog from './RatingDialog/RatingDialog';
import template from './OccurrenceList.html?raw';
// Template-only widget (used via data-dojo-type in OccurrenceList.html, not as a value in code) → bare import.
import "../../../moreCore/UI/EntityBased/EntitySelect/EntitySelect";
// NOTE (JS2TS): xstyle/css!./OccurrenceList.css was already commented out. Tabulator = runtime global; DOM-heavy → dom-construct aliased.
declare const Tabulator: any;
const domConstruct: any = domConstructTyped;

class OccurrenceList extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    homePanel: any = null;
    table: any = null;
    jsonData: any = null;
    _jsonResponse: any = null;

    ratingRequests: any = null;
    ratingRequestTimeout: any = null;
    ratingRequestCount: any = null;

    _isEditor = false;
    _alternativeLoading: any = null;

    _currentOffset = 0;
    _maxResponseCount = 50;
    _totalCount = -1;

    lockPropertyEdit = false;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
    }

    startup(bReload?: any): void {

        if (bReload === true) {
            //console.debug("list startup: load");
            this.loadOccurrences();
            return;
        }

        if (this.jsonData != null) {
            this._renderTable();
        }
    }

    _onClick_Btn_LoadNext(evt?: any): void {
        this.loadOccurrences(this._currentOffset + this._maxResponseCount);

        domClass.add(this.btnLoadNext, "w3-disabled");
    }

    displayPagingButton(): void {
        if (this.jsonData.length >= this._totalCount) {
            domClass.add(this.btnLoadNext, "w3-hide");
        } else {
            domClass.remove(this.btnLoadNext, "w3-hide");
        }
    }

    loadOccurrences(newOffset?: any, newCountLimit?: any): void {
        //console.debug("list loadOccurrences");
        //this.StandbyStart();

        if (typeof (newOffset) == "number") {
            if (newOffset < 0) {
                newOffset = 0;
            }
            this._currentOffset = newOffset;
        }

        if (typeof (newCountLimit) == "number") {
            if (newCountLimit > 0) {
                this._maxResponseCount = newCountLimit;
            }
        }

        this.emit("requestList", { offset: this._currentOffset, count: this._maxResponseCount });

        this.StandbyStart();

        //    if (this._alternativeLoading != null) {
        //        this._alternativeLoading(this._currentOffset, this._maxResponseCount);
        //        return;
        //    }
    }

    setList(data: any): void {

        this.StandbyStop();
        this._jsonResponse = data;

        let result = data;

        this.jsonData = result.entitylist;
        this._totalCount = result.totalResultCount;
        this._currentOffset = 0;
        domAttr.set(this.txtTotalCount, "innerHTML", this._totalCount);

        console.log("_onLoadOccurrencesResponse", this.jsonData)

        this._renderTable();

        domClass.remove(this.btnLoadNext, "w3-disabled");
    }

    _onLoadOccurrencesResponse(response: any): void {
        //console.log("_onLoadOccurrencesResponse", response);

        if (typeof (response) == "string") {
            response = JSON.parse(response);
        }

        this.setList(response);

    }

    _onLoadOccurrencesError(error: any): void {
        this.StandbyStop();

        alert("Liste kann nicht geladen werden: " + error.Message);
        //this.handleErrorResponse(error.Message);

        domClass.remove(this.btnLoadNext, "w3-disabled");
    }

    _onLoadAddedOccurrencesResponse(response: any, newOffset?: any): void {
        this.StandbyStop();
        this._jsonResponse = response;
        let result = JSON.parse(response);
        this._totalCount = result.totalResultCount;


        domAttr.set(this.txtTotalCount, "innerHTML", this._totalCount);

        if (this.jsonData == null) {
            this.jsonData = [];
        }

        this.jsonData = this.jsonData.concat(result.entitylist);

        if (typeof (newOffset) == "number") {
            this._currentOffset = newOffset;
        }

        if (this._totalCount == 0) {
            this._renderTable();
        } else {
            this._renderTable(result.entitylist);
        }

        domClass.remove(this.btnLoadNext, "w3-disabled");
    }

    tableFormatter(cell: any, formatterParams: any, onRendered: any): any {

        let data = cell.getData();
        let value = cell.getValue();

        if (data.ref_vt_property.is_value_list === true) {
            for (var i = 0; i < data.ref_vt_property.EL_vt_property_value_vt_property.length; i++) {
                let propValue = data.ref_vt_property.EL_vt_property_value_vt_property[i];

                if (propValue.ID == value) {
                    return propValue.bezeichnung;
                }
            }
        }

        return value;
    }

    tableFormatterReporter(cell: any, formatterParams: any, onRendered: any): any {

        let data = cell.getData();
        let value = cell.getValue();


        if (data.ref_reporter.Classname == "Employee_LDAPgroup") {
            value = this.createFontawesomeIcon("fas fa-users", "&nbsp;").outerHTML + value;
        }

        if (data.ref_reporter && data.ref_reporter_actual) {
            if (data.ref_reporter.ID != data.ref_reporter_actual.ID) {
                value += "\r\n(" + data.ref_reporter_actual.DispName + ")";
            }
        }

        return value;
    }

    tableFormatterStatus(cell: any, formatterParams: any, onRendered: any): any {

        let data = cell.getData();
        let value = cell.getValue();

        let progress = data.ref_progress_marker;
        if (progress && this._isEditor == true) {
            let icon = this.createFontawesomeIcon("fas fa-flag roundest brightTransparentBG");
            domStyle.set(icon, "padding", "0.4em");
            domStyle.set(icon, "text-shadow", "1px 1px 1px var(--darkTransparent)");
            domStyle.set(icon, "marginRight", "0.4em");
            switch (progress.current_status_level) {
                case 1: // grün
                    domClass.add(icon, "w3-text-green");
                    break;
                case 5: // orange
                    domClass.add(icon, "w3-text-orange");
                    break;

                case 10: // rot
                    domClass.add(icon, "w3-text-red");
                    break;

                default:
                    domClass.add(icon, "w3-text-gray w3-opacity");
                    break;
            }

            if (progress.dispname) {
                domAttr.set(icon, "title", progress.dispname);
            }

            value = icon.outerHTML + value;
        }

        var rawColor = data.ref_occurrence_status?.Coloration;

        if (rawColor == null || typeof (rawColor) == "undefined") {
            return value;
        }

        var rawTextColor = "";

        //console.log("occurrenceList tableFormatterStatus color", rawColor);

        if (typeof (rawColor) == "string") {// wegen Kompatibilität mit neuer Entity-API!
            rawColor = data.ref_occurrence_status.Coloration.split(":")[1];
            rawTextColor = data.ref_occurrence_status.Coloration.split(":")[0];
        } else {
            rawColor = data.ref_occurrence_status.Coloration.pitBGR?.split(":")[1];
            rawTextColor = data.ref_occurrence_status.Coloration.pitBGR?.split(":")[0];
        }

        if (rawColor?.length == 6) {
            var hexColor = rawColor.slice(4) + rawColor.slice(2, 4) + rawColor.slice(0, 2);

            domStyle.set(cell.getElement(), "background-color", "#" + hexColor);
        }

        if (rawTextColor?.length == 6) {
            var hexColor: any = rawTextColor.slice(4) + rawTextColor.slice(2, 4) + rawTextColor.slice(0, 2);

            domStyle.set(cell.getElement(), "color", "#" + hexColor);
        }

        // pit-Farbe wird in BGR zurückgegeben. ganz toll.
        // aabbcc:ddeeff der hintere Teil interessiert uns

        return value;
    }

    tableFormatterDateTime(cell: any, formatterParams: any, onRendered: any): any {

        var data = cell.getData();
        var value = cell.getValue();

        var date = new Date(value);

        //console.log("tableFormatterDateTime", data);

        if (value == "") {
            return "";
        }

        value = dojoDateLocale.format(date, { locale: 'de-de', datePattern: "dd.MM.yyyy", timePattern: "HH:mm" } as any);

        // bei "zu erledigen bis" Rotfärbung falls datum abgelaufen und noch nicht erledigt!
        if (cell.getField() == "To_complete_by") {

            // wenn der Datensatz ein "Termin" ist, dann hinten dazuschreiben
            //console.debug("data to_complete_by", data);
            if (data.is_complete_by_appointment == true) {
                value = value + this.translations["OccurrenceList__TableCol_DateCompleteBy_AddonAppointment"];
            }

            if (date < new Date() && data.ref_occurrence_status.sorting < 29) { // kleiner als "storno" (erledigt = 30)
                var dom = cell.getElement();

                domStyle.set(dom, "color", "red");
            }
        }

        return value;
    }

    tableFormatterRating(cell: any, formatterParams: any, onRendered: any): void {

    }

    rowFormatter(row: any): void {
        //row - row component

        var data = row.getData();


        if (data.is_escalation === true) {
            domClass.add(row.getElement(), "w3-pale-red w3-text-red");
            domStyle.set(row.getElement(), "font-weight", "bold");
        }

        // Bewertungszelle unsichtbar machen falls noch nicht freigeschaltet
        //var column = row.getTable().getColumn("evaluation_occurrence");
        //var ratingCell = row.getCell(column);
        //console.log("rowFormatter", ratingCell);

        //if (this.checkRatingEnabled(ratingCell) != true) {
        //    domClass.add(ratingCell.getElement(), "w3-disabled");
        //}

    }

    //custom formatter definition
    tableBtnEdit(cell: any, formatterParams: any, onRendered: any): any { //plain text value
        var data = cell.getRow().getData();
        var container = domConstruct.create("div");
        //console.log("tableBtnEdit", data, this._isEditor);
        if (data.ref_occurrence_status.is_edit_occurence_by_reporter === true) {
            var button = domConstruct.create("div");
            domClass.add(button, "w3-padding-small w3-center mds-bg-gray mds-hover-dark");
            domAttr.set(button, "innerHTML", "<i class='fa fa-pencil'></i>" + this.translations["OccurrenceList__TableBtn_Edit"]);
            domAttr.set(button, "title", this.translations["OccurrenceList__TableBtn_EditTooltip"]);//"Meldung anpassen");
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "clickTableEdit", cell));


        }

        if (true) {//(this._isEditor == true) {
            var button = domConstruct.create("div");
            domClass.add(button, "w3-padding-small w3-center mds-bg-gray mds-hover-dark");
            domAttr.set(button, "innerHTML", "<i class='fa fa-external-link-square'></i>" + this.translations["OccurrenceList__TableBtn_Show"]);
            domAttr.set(button, "title", this.translations["OccurrenceList__TableBtn_ShowTooltip"]);//"Meldung öffnen");
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "clickTableOpen", cell));

            //console.log("editbutton", button);
        }

        return container;

    }


    ratingDialog(cell: any, strEntity?: any): void {

        //console.log("rating", cell, strEntity);
        var actualEntity = null;
        var ratedEntity = null;

        if (typeof (strEntity) != "undefined" && strEntity != null) {
            actualEntity = JSON.parse(strEntity);
            ratedEntity = actualEntity;
        }
        else if (cell != null) {
            actualEntity = cell.getData();
        }

        if (cell != null) {
            ratedEntity = cell.getData();
        }

        console.log("rating", actualEntity, ratedEntity);

        // jetzt haben wir ein ActualEntity das noch so aus der Datenbank gekommen ist
        // und evtl. ein davon abweichendes ratedEntity, das schon vom Tabulator manipuliert worden ist
        // für die Prüfung schauen wir ob das actualEntity bewertet werden darf
        // der Dialog bekommt das bereits manipulierte Objekt

        if (actualEntity == null) {
            return;
        }

        if (this.checkRatingEnabled(null, actualEntity) != true) {
            console.warn("Bewertung für Datensatz nicht möglich", actualEntity);

            var dlg: any = new GenericDialog();
            dlg.hideSubtitleNode();
            domStyle.set(dlg.textNode, "height", "unset");
            dlg.set("header", this.translations["OccurrenceRating__DialogHeading"].format(actualEntity.Number));//"Bewertung");
            dlg.set("content", this.translations["OccurrenceRating__DialogMessageRatingUnavailable"]);//"Die angeforderte Meldung kann nicht bewertet werden.");
            dlg.set("close", true);
            dlg.show();

            this.removeUrlAction("rate");

            return;
        }

        var dlg2: any = new RatingDialog();
        dlg2.set("entity", ratedEntity, "evaluation_occurrence", "note_evaluation", "Number");
        dlg2.set("callback", lang.hitch(this, "ratingDialogCallback", cell));

        this.setUrlAction("rate", [{ Name: "id", Value: ratedEntity.ID }]);

        dlg2.startup();

    }

    ratingDialogCallback(cell: any, result: any, rating?: any): void {
        //console.log("dialog callback", cell, result, rating);
        if (result == 1) {
            if (cell != null) {
                cell.getData().evaluation_occurrence = rating;
                this.lockPropertyEdit = true;
                cell.setValue(rating);
                this.lockPropertyEdit = false;

                this.table.updateOrAddData(this.jsonData);
            }

        } else {
            if (cell != null) {
                cell.cancelEdit();

                this.lockPropertyEdit = true;
                cell.setValue(cell.getOldValue(), false, "cancel");
                this.lockPropertyEdit = false;
            }

            //console.log("dialog cancel", cell.getOldValue(), cell.getValue());
        }
    }

    checkRatingEnabled(cell: any, entity?: any): any {
        var data = null;
        //console.log("checkRatingEnabled", cell, entity);
        if (cell != null) {
            data = cell.getRow().getData();
        }

        else if (typeof (entity) != null && typeof (entity) == "object") {
            data = entity;
        } else {
            return false;
        }

        //console.log("checkRatingEnabled", data, oldValue);

        return data.ref_occurrence_status.is_enable_rating == true && (
            data.evaluation_occurrence == null ||
            data.evaluation_occurrence == 0);

        //ref_occurrence_status.is_enable_rating
    }

    _onPropertyEdited(cell: any): void {

        if (this.lockPropertyEdit == true) {
            return;
        }

        //console.log("property changed", cell, );

        var data = cell.getData();

        //if (cell.getField() == "evaluation_occurrence") {
        //    //console.log("rating changed", data, JSON.parse(this._jsonResponse));

        //    // jetzt ist es so, dass der Tabulator den neuen Wert schon auf das json-Objekt geschrieben hat
        //    // wir müssen im nächsten Schritt aber prüfen, ob der Aufruf des Bewertungsdialogs zulässig ist
        //    // und bereits bewertete Objekte sind verboten.
        //    // deswegen ein Backup der json-Daten parsen und das Objekt vor der Bearbeitung suchen. hmpf.

        //    var jsonBak = JSON.parse(this._jsonResponse);
        //    var entitylist = jsonBak.entitylist;
        //    var strEntity = "";

        //    for (var i = 0; i < entitylist.length; i++) {
        //        var bakEntity = entitylist[i];

        //        if (bakEntity.ID == data.ID) {

        //            strEntity = JSON.stringify(bakEntity)
        //            break;
        //        }
        //    }

        //    this.ratingDialog(cell, strEntity);
        //}
    }


    //column definition in the columns array


    _renderTable(addedData?: any): void {

        //console.log("_renderTable", addedData);

        domAttr.set(this.txtCurrentCount, "innerHTML", this.jsonData.length);

        this.displayPagingButton();

        if (typeof (addedData) != "undefined" && this.table != null) {
            this.table.addData(addedData, false); // false = unten hinzufügen
            return;
        }

        if (this.table != null) {
            this.table.destroy();
            domConstruct.empty(this.tableContainer);
            this.table = null;
        }

        if (this.jsonData == null || typeof (this.jsonData) == "undefined" || this.jsonData.length == 0) {
            domClass.remove(this.loadMessage, "w3-hide");

            domAttr.set(this.loadMessage, "innerHTML", this.translations["General_noEntries"]);
            return;
        }

        // unterschiedliche Layouts für den Melder und den Bearbeiter
        var tableColumns: any[] = [
            { title: this.translations["OccurrenceList__TableCol_Number"]/*"Nr"*/, field: "Number", width: 65, editor: false, headerSort: false },
            {
                title: this.translations["OccurrenceList__TableCol_ReportingDate"]/*"Datum"*/, field: "Time", width: 90, editor: false, formatter: this.tableFormatterDateTime, headerSort: false
            },
            { title: this.translations["OccurrenceList__TableCol_Building"]/*"Meldender"*/, field: "ref_building.tmp_label", editor: false, headerSort: false },
            { title: this.translations["OccurrenceList__TableCol_Reporter"]/*"Meldender"*/, field: "ref_reporter.DispName", editor: false, headerSort: false, formatter: lang.hitch(this, this.tableFormatterReporter) },
            { title: this.translations["OccurrenceList__TableCol_Executer"]/*"Bearbeiter"*/, field: "tmp_ref_scheduled_task_executer.ref_employee.DispName", editor: false, headerSort: false },
            { title: this.translations["OccurrenceList__TableCol_Requesttype"]/*"Meldungsart"*/, field: "ref_occurrence_type.Name", width: 120, editor: false, headerSort: false },
            { title: this.translations["OccurrenceList__TableCol_Costcenter"]/*"Kostenstelle"*/, field: "ref_cost_center2_reported.Cost_center", width: 70, editor: false, headerSort: false },
            { title: this.translations["OccurrenceList__TableCol_OccurrenceStatus"]/*"Meldungsstatus"*/, field: "ref_occurrence_status.description", width: 100, editor: false, formatter: lang.hitch(this, this.tableFormatterStatus), headerSort: false },
            { title: this.translations["OccurrenceList__TableCol_Description"]/*"Problembeschreibung"*/, field: "tmp_description_web", width: 160, editor: false, /*formatter: this.tableFormatterStatus,*/ headerSort: false },
            //{ title: this.translations["OccurrenceList__TableCol_History"]/*"Rückmeldung"*/, field: "feedback", editor: false },
            //{ title: this.translations["OccurrenceList__TableCol_DateCompleteBy"]/*"zu erledigen bis"*/, field: "To_complete_by", editor: false, formatter: this.tableFormatterDateTime },
            //{ title: this.translations["OccurrenceList__TableCol_Rating"]/*"Bewertung"*/, field: "evaluation_occurrence", editor: "star", formatter: "star", editable: lang.hitch(this, "checkRatingEnabled"), headerSort: false },
            //{ title: this.translations["OccurrenceList__TableCol_Actions"]/*"Aktionen"*/, formatter: lang.hitch(this, "tableBtnEdit"), width: 50, align: "center", headerSort: false },//cellClick: lang.hitch(this, "clickTableEdit")  },

        ];

        if (this._isEditor == true) {
            tableColumns = [
                { title: this.translations["OccurrenceList__TableCol_Number"]/*"Nr"*/, field: "Number", width: 65, editor: false, headerSort: false },
                {
                    title: this.translations["OccurrenceList__TableCol_ReportingDate"]/*"Datum"*/, field: "Time", width: 90, editor: false, formatter: this.tableFormatterDateTime, headerSort: false
                },
                { title: this.translations["OccurrenceList__TableCol_Building"]/*"Meldender"*/, field: "ref_building.tmp_label", editor: false, headerSort: false },
                { title: this.translations["OccurrenceList__TableCol_Reporter"]/*"Meldender"*/, field: "ref_reporter.DispName", editor: false, headerSort: false, formatter: lang.hitch(this, this.tableFormatterReporter) },
                { title: this.translations["OccurrenceList__TableCol_Executer"]/*"Bearbeiter"*/, field: "tmp_ref_scheduled_task_executer.ref_employee.DispName", editor: false, headerSort: false },
                { title: this.translations["OccurrenceList__TableCol_Requesttype"]/*"Meldungsart"*/, field: "ref_occurrence_type.Name", width: 120, editor: false, headerSort: false },
                { title: this.translations["OccurrenceList__TableCol_Costcenter"]/*"Kostenstelle"*/, field: "ref_cost_center2_reported.Cost_center", width: 70, editor: false, headerSort: false },
                { title: this.translations["OccurrenceList__TableCol_OccurrenceStatus"]/*"Meldungsstatus"*/, field: "ref_occurrence_status.description", width: 100, editor: false, formatter: lang.hitch(this, this.tableFormatterStatus), headerSort: false },
                { title: this.translations["OccurrenceList__TableCol_Description"]/*"Problembeschreibung"*/, field: "tmp_description_web", width: 160, editor: false, /*formatter: this.tableFormatterStatus,*/ headerSort: false },
                //{ title: this.translations["OccurrenceList__TableCol_History"]/*"Rückmeldung"*/, field: "feedback", editor: false },
                //{ title: this.translations["OccurrenceList__TableCol_DateCompleteBy"]/*"zu erledigen bis"*/, field: "To_complete_by", editor: false, formatter: lang.hitch(this, this.tableFormatterDateTime), headerSort: false },
                //{ title: this.translations["OccurrenceList__TableCol_Rating"]/*"Bewertung"*/, field: "evaluation_occurrence", editor: "star", formatter: "star", editable: lang.hitch(this, "checkRatingEnabled"), headerSort: false },
                //{ title: this.translations["OccurrenceList__TableCol_Actions"]/*"Aktionen"*/, formatter: lang.hitch(this, "tableBtnEdit"), width: 50, align: "center", headerSort: false },//cellClick: lang.hitch(this, "clickTableEdit")  },

            ];
        }

        this.table = new Tabulator(this.tableContainer, {
            data: this.jsonData,
            layout: "fitColumns",
            rowFormatter: lang.hitch(this, "rowFormatter"),
            rowClick: lang.hitch(this, "clickRow"),
            selectableCheck: lang.hitch(this, "tableSelectableCheck"),
            //height: "",
            columns: tableColumns,
            cellEdited: lang.hitch(this, "_onPropertyEdited"),
            headerSort: false
            //initialSort: [
            //    { column: "Time", dir: "desc" } //sort by this first
            //]
        });

        domClass.add(this.loadMessage, "w3-hide");
    }

    clickTableEdit(cell: any, evt: any): void {
        //console.log("clickTableEdit", cell, evt);
        var data = cell.getRow().getData();
        if (data.ref_occurrence_status.is_edit_occurence_by_reporter !== true) {
            return;
        }

        var entityID = data.ID;

        this.homePanel.showOccurrenceDialog(entityID);

        evt.stopPropagation();
    }

    clickTableOpen(cell: any, evt: any): void {
        //console.log("clickTableOpen", cell, evt);
        var data = cell.getRow().getData();

        var entityID = data.ID;

        this.homePanel.showOccurrenceDialog(entityID, true); // Schreibschutz auf true setzen!

        evt.stopPropagation();
    }

    tableSelectableCheck(row: any): any {
        var data = row.getData();

        //return this._isEditor == true || data.ref_occurrence_status.is_edit_occurence_by_reporter == true;
        return true; // JDM
    }

    clickRow(evt: any, row: any): void {

        var data = row.getData();

        if (this.tableSelectableCheck(row) != true) // also Editorrecht ist auch keins?
        {
            return;
        }

        console.debug("clickRow", data);;

        var entityID = data.web_guid;

        this.homePanel.showOccurrenceDialog(entityID, data.ref_occurrence_status.is_edit_occurence_by_reporter != true); // Schreibschutz auf true setzen!
    }
}
OccurrenceList.prototype.declaredClass = 'WidgetCollection.JDM.Occurrence.OccurrenceList';

export default mdsWidget(OccurrenceList);
